import React,{Component} from "react";
import { connect } from "react-redux";
import {Bar} from "react-chartjs-2";
import { translate } from "react-i18next";

const color =["#FFCDD2","#E1BEE7","#CE93D8","#D1C4E9","#9FA8DA","#BBDEFB","#C8E6C9","#C5E1A5","#F0F4C3","#FFE0B2","FFF59D","#ECEFF1","#D7CCC8","#FF8A65","#FFFF00","#B2FF59","#64FFDA","#7C4DFF","#D500F9","#18FFFF","#00E676","#FF6E40","#757575"]
function sortNumber(a,b) {
    return a - b;
}
class Chart extends Component {	
	constructor(props) {
        super(props);

        this.state = { 
        	dateline :[],
        };// props.location.state.campaign };
    }
    getData(){
    	let isExists = this.props.chart[this.props.charttype]
    	if(!isExists){
			return "No Data"
    	} else {
    		let chart=isExists.data
    		var data={}
    		data.data=[]
	    	data.label=[]
	    	switch(this.props.charttype){
	    		case "bydate":
		    		if (chart!=undefined){
		    			for (var key =0; key < chart.length;key++){
		    				let d =chart[key].date.split("-")
		    				let date=d[2]+"-"+d[1]
		    				data.label.push(date)
		    				data.data.push(chart[key].num)
		    			}
		    			return data
		    		}else{
		    			data.label=[0]
		    			data.data=[0]
		    			return data
		    		}
	    		case "byhour":
		    		if (chart!=undefined){
		    			for (var key =0; key < chart.length;key++){
		    				if (chart[key].time===undefined){
			    					chart[key].time=0
			    				}
		    				data.label.push(chart[key].time)
		    				data.data.push(chart[key].num)
		    			}
		    			data.label.sort(sortNumber)
		    			return data
	    			}else{
		    			data.label=[0]
		    			data.data=[0]
		    			return data
		    		}
	    		case "byarea":
	    			if (chart!=undefined){
		    			for (var key =0; key < chart.length;key++){
		    				data.label.push(chart[key].zoneName)
		    				data.data.push(chart[key].num)
		    			}
		    			return data
		    		}else{
		    			data.label=[0]
		    			data.data=[0]
		    			return data
		    		}
	    		case "byad":
		    		if (chart!=undefined){
		    			data.stack=[]
		    			for (var i =0; i<chart.length;i++){
		    				if (i === 0){
		    					data.label.push(chart[i].date)
		    					data.stack.push(chart[i].zoneName)
		    					data.data[chart[i].date]=[]
		    					data.data[chart[i].date][chart[i].zoneName]=chart[i].num
		    				}else {
	    						if (data.label.indexOf(chart[i].date)!==-1){
	    							if (data.stack.indexOf(chart[i].zoneName)===-1){
		    							data.stack.push(chart[i].zoneName)
		    						}
	    							data.data[chart[i].date][chart[i].zoneName]=chart[i].num
	    						} else {
	    							data.label.push(chart[i].date)
	    							if (data.stack.indexOf(chart[i].zoneName)===-1){
			    						data.stack.push(chart[i].zoneName)
			    					}
			    					data.data[chart[i].date]=[]
			    					data.data[chart[i].date][chart[i].zoneName]=chart[i].num
	    						}
		    				}
		    			}
						return data
					}else{
		    			data.label=[0]
		    			data.data=[0]
		    			return data
		    		}
	    		case "bydt":
		    		if (chart!=undefined){
		    			data.stack=[]
		    			for (var i =0; i<chart.length;i++){
		    				let d =chart[i].date.split("-")
		    				let date=d[2]+"-"+d[1]

		    				if (chart[i].time===undefined){
			    					chart[i].time=0
			    				}
		    				if (i === 0){
		    					data.label.push(date)
		    					data.stack.push(chart[i].time)
		    					data.data[date]=[]
		    					data.data[date][chart[i].time]=chart[i].num
		    				}else {
	    						if (data.label.indexOf(date)!==-1){
	    							if (data.stack.indexOf(chart[i].time)===-1){
		    							data.stack.push(chart[i].time)
		    						}
	    							data.data[date][chart[i].time]=chart[i].num
	    						} else {
	    							data.label.push(date)
	    							if (data.stack.indexOf(chart[i].time)===-1){
			    						data.stack.push(chart[i].time)
			    					}
			    					data.data[date]=[]
			    					data.data[date][chart[i].time]=chart[i].num
	    						}
		    				}
		    			}
		    			data.stack.sort(sortNumber)
						return data
					}else{
		    			data.label=[0]
		    			data.data=[0]
		    			return data
		    		}
    			case "byat":
	    			if (chart!=undefined){
		    			data.stack=[]
		    			for (var i =0; i<chart.length;i++){
		    				if (chart[i].time===undefined){
			    					chart[i].time=0
			    				}
		    				if (i === 0){
		    					data.label.push(chart[i].zoneName)
		    					data.stack.push(chart[i].time)
		    					data.data[chart[i].zoneName]=[]
		    					data.data[chart[i].zoneName][chart[i].time]=chart[i].num
		    				}else {
	    						if (data.label.indexOf(chart[i].zoneName)!==-1){
	    							if (data.stack.indexOf(chart[i].time)===-1){
		    							data.stack.push(chart[i].time)
		    						}
	    							data.data[chart[i].zoneName][chart[i].time]=chart[i].num
	    						} else {
	    							data.label.push(chart[i].zoneName)
	    							if (data.stack.indexOf(chart[i].time)===-1){
			    						data.stack.push(chart[i].time)
			    					}
			    					data.data[chart[i].zoneName]=[]
			    					data.data[chart[i].zoneName][chart[i].time]=chart[i].num
	    						}
		    				}
		    			}
		    			data.stack.sort(sortNumber)
						return data
					}else{
						data.data=[0]
	    				data.label=[0]
						return data
					}
				case "bydriver":
					if (chart!=undefined){
						if ( chart[0].time===-1){
							for (var key =0; key < chart.length;key++){
		    					data.label.push(chart[key].date)
		    					data.data.push(chart[key].num)
							}
							return data
						}else {
							for (var key =0; key < chart.length;key++){
		    					data.label.push(chart[key].time)
		    					data.data.push(chart[key].num)
							}
			    			return data
						}
					}else{
						data.data=[0]
	    				data.label=[0]
						return data
					}
				// case "bydriverdisplay":
				// 	data.hour=[]
				// 	if (chart!=undefined){
				// 		for (var key =0; key < chart.length;key++){
	   //  					data.label.push(chart[key].devID)
	   //  					data.data.push(chart[key].num)
	   //  					data.hour.push(Math.round(chart[key].num*10/3600*100)/100)
				// 		}
				// 		return data
				// 	}else{
				// 		data.data=[0]
	   //  				data.label=[0]
				// 		return data
				// 	}
	    		default:
	    			data.data=[0]
	    			data.label=[0]
	    			return data
	    	}
	    }
    }
    getChartTitle(){
    	const { t } = this.props
    	switch(this.props.charttype){
    		case "bydate":
    			return t("ViewByDate")
    		case "byhour":
    			return t("ViewByHour")
    		case "byarea":
    			return t("ViewByArea")
    		case "bydt":
    			return t("ViewByDateTime")
    		case "byad":
    			return t("ViewByDateArea")
    		case "byat":
    			return t("ViewByAreaTime")
    		case "bydriver":
    			return t("ViewByDriver")
    		// case "bydriverdisplay":
    		// 	return t("ViewByDriverDisplay")
    		default:
    			return t("NoData")
    	}
    }

    getDatasets(){
    	const { t } = this.props
    	let chartData=this.getData()
    	if (chartData==="No Data"){
    		var data = {
				labels: [t("NoData")],
				datasets: [{
			    	label: "",
			      	data: [0],
				}]
			}
    		return data
    	} else {
	    	switch(this.props.charttype){
	    		case "bydate":
	    		case "byhour":
	    		case "byarea":
	    		case "bydriver":
		    		var data = {
						labels: chartData.label,
						datasets: [{
							label:"Num",
					    	backgroundColor: '#73c5ff',
					    	borderColor: '#73c5ff',
					      	borderWidth: 1,
					      	hoverBackgroundColor: 'rgba(255,99,132,0.4)',
					      	hoverBorderColor: 'rgba(255,99,132,1)',
					      	data: chartData.data,
						},
						{
					    	type:"line",
					    	fill:false,
					    	backgroundColor:"blue",
					    	borderColor:"lightblue",
					      	data: chartData.data,
						}]
					}
					return data
	    		case "byad":
	    		case "bydt":
	    		case "byat":
	    			var datasets = []
	    			for (var i =0; i<chartData.stack.length;i++){
    					var stack = chartData.stack[i]
    					var dataset={}
    					dataset.data=[]
    					dataset.stack=1
    					dataset.label=stack
    					dataset.backgroundColor=color[i]
    					for (var j = 0;j<chartData.label.length;j++){
    						var label = chartData.label[j]
    						if(chartData.data[label][stack]){
    							dataset.data.push(chartData.data[label][stack])
    						}else {
    							dataset.data.push(0)
    						}
    						
    					} 
    					datasets.push(dataset)
	    			}
	    			var data = {
	    				labels:chartData.label,
	    				datasets:datasets
	    			}
	    			return data
	    	// 	case "bydriverdisplay":
		    // 		var data = {
						// labels: chartData.label,
						// datasets: [{
						// 	label:"Num",
					 //    	stack:1,
					 //    	backgroundColor: '#73c5ff',
					 //    	borderColor: '#73c5ff',
					 //      	borderWidth: 2,
					 //      	hoverBackgroundColor: 'rgba(255,99,132,0.4)',
					 //      	hoverBorderColor: 'rgba(255,99,132,1)',
					 //      	data: chartData.data,
						// },
						// {
						// 	label:"Hour",
					 //    	stack:1,
					 //    	backgroundColor: '#CE93D8',
					 //      	hoverBackgroundColor: '#CE93D8',
					 //      	data: chartData.hour,
						// },
						// ]
						// datasets: [{
					 //    	type:"line",
					 //    	fill:true,
					 //    	backgroundColor:"blue",
					 //    	borderColor:"lightblue",
					 //      	data: chartData.data,
						// },
						// {
					 //    	type:"line",
					 //    	fill:false,
					 //    	backgroundColor:"blue",
					 //    	borderColor:"lightblue",
					 //      	data: chartData.hour,
						// }
						// ]
					// }
					// return data
	    		default:
					return {}
					    	}
	    }
	}
	legend(){
		switch(this.props.charttype){
			case "bydate":
			case "byhour":
			case "byarea":
			case "bydriver":
			// case "bydriverdisplay":
				return 0;
			default:
				return 1;
		}
	}
	tooltips(){
		switch(this.props.charttype){
			case "bydate":
			case "byhour":
			case "byarea":
			case "bydriver":
				let tooltip={
					enabled:true,
					mode: 'nearest',
					intersect: true,
				}
				return tooltip;
			default:
				let tooltips={
					enabled:true,
					mode: 'index',
					intersect: true,
					position:"nearest"
				}
				return tooltips;
		}
	}
	datasetKeyProvider(){ return Math.random(); } 
	render() {
		let title =this.getChartTitle()
		var data = this.getDatasets()
		let tooltips=this.tooltips()
		return (
		<div style={{paddingBottom:"10%",margin:5}}>
		<h2 >{title}</h2>
			<Bar
				datasetKeyProvider={this.datasetKeyProvider}
				data={data}
				width={window.innerWidth*75/100}
				height={300}
				options={{
					legend: {
			            display:this.legend(),
			        },
					tooltips: tooltips,
					responsive: true,
					maintainAspectRatio: false,
					scales: {
				      yAxes: [{
				        ticks: {
				          beginAtZero: true
				        }
				      }],
				      xAxes: [{
				        stacked: true
				      }]
				    }
				}}>
			</Bar>
		</div>
		);
	}
}

function mapStateToProps(state) {
    const { chart } = state;
    return {
        chart
    };
}

const Charts = connect(mapStateToProps)(
    translate("translations")(Chart)
);

export default Charts;


// WEBPACK FOOTER //
// ./src/CampaignDetailCharts/Chart.js